import React, {useState, useEffect, useContext, useRef} from "react";
import {useParams} from "react-router-dom";
import ListPanel from '../administration/components/ListPanel';
import EditPanel from '../administration/components/EditPanel';
import {useHistory} from 'react-router-dom';
import {store} from '../../context/store';
import {INPUT_TYPE_TEXT} from "../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../constants/input-types";
import {INPUT_TYPE_SELECT} from "../../constants/input-types";
import {INPUT_TYPE_SELECTFROMDBCONCATENATION} from "../../constants/input-types";
import {functions} from "../../constants/common-functions";
import {TRUE} from "../../constants/general-constants";
import {STRINGIFY} from "../../constants/general-constants";
import AdminListPanelGeographies from '../administration/components/AdminListPanelGeographies';
import {YES_NO_OPTIONS} from "../../constants/general-constants";
import EditButtonPanel from '../administration/components/EditButtonPanel';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";

export default function AdministrationGeographiesEdit(){
	
	const globalState = useContext(store);
	const history = useHistory(); 
	const [parentId, setParentId] = useState("0");
	const [entityCode, setEntityCode] = useState("");
	const [entityName, setEntityName] = useState("New Geography");
	const [entityDescription, setEntityDescription] = useState("");
	
	const refParentId = useRef(null);
	const refCode = useRef(null);
	const refName = useRef(null);
	const refDescription = useRef(null);
	const refIsCountry= useRef(null);
	
	const id = useParams()["id"];
	
	useEffect(() => {
		loadData();
	}, [id]);
	
	const loadData = () => {
		const timer = setTimeout(() => {
			functions.getObjectFromAjax("/resolution/geography?id=" + id, null, initialiseFields);
		}, 100);
	};
	
	const getEntityCode = () => {
		return refCode.current.value;
	};
	
	const getEntityName = () => {
		return refName.current.value;
	};
	
	const initialiseFields = (entity) => {
		const timer = setTimeout(() => {
			try{
				setParentId(entity.parentId);
				setEntityCode(entity.code);
				setEntityName(entity.name);
				setEntityDescription(entity.description);
				refParentId.current.value=entity.parentId;
				refCode.current.value = entity.code;
				refName.current.value = entity.name;
				refDescription.current.value = entity.description;
				if(entity.isCountry === true){
					refIsCountry.current.value="Y";
				}
				else{
					refIsCountry.current.value="N";
				}
			}
			catch(e){}
		}, 100);
	
		
	};
	
	const mainComponentRows = [
		{ref:refParentId, id:"1", title:"Parent", inputType:INPUT_TYPE_SELECTFROMDBCONCATENATION, restUrl:"voyansiadmingetconcatenationgeographies"},
		{ref:refCode, id:"2", title:"Code", inputType:INPUT_TYPE_TEXT},
		{ref:refName, id:"3", title:"Name", inputType:INPUT_TYPE_TEXT},
		{ref:refDescription, id:"4", title:"Description", inputType:INPUT_TYPE_TEXTAREA},
		{ref:refIsCountry, id:"5", title:"Is Country?", inputType:INPUT_TYPE_SELECT, options:YES_NO_OPTIONS}
	];
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	const administrationHeader = {
		display:"flex",
		height:"60px",
		paddingLeft:"20px",
		alignItems:"center",
		color:"black"
	};
	
	const contentPanel = {
		display:"flex",
		width:"100%"
	};
	
	const getSubmitObject = () => {
		let tempIsCountry = false;
		if(refIsCountry.current.value === "Y"){
			tempIsCountry = true;
		}
		let submitObject = {
			id:id,
			parentId:refParentId.current.value,
			code:refCode.current.value,
			name:refName.current.value,
			description:refDescription.current.value,
			svg:"",
			lat:"",
			lng:"",
			isCountry:tempIsCountry
		};
		return submitObject
	}
	
	const goSubmit = () => {
		
		functions.submitAjax("/resolution/geographysave", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
		
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		goCancel();
	};
	
	const goDelete = () => {
		functions.submitAjax("/resolution/geographydelete", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
	};
	
	const goCancel = () => {
		history.goBack();
	};

	return (
		
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
				<div style={administrationHeader}>
					Geography Edit: {entityName}
				</div>
				<div style={contentPanel}>
					<EditPanel
					title="Main Details"
						componentRows = {mainComponentRows}
					/>
					<AdminListPanelGeographies
					id={id}
					/>
				</div>
				<EditButtonPanel
					id={id}
					goSubmit={goSubmit}
					goDelete={goDelete}
					goCancel={goCancel}
					checkCodeUrl="geographies"
					getCodeFunction={getEntityCode}
					getNameFunction={getEntityName}
				/>
			</div>
			
	
	);
}